<template>
  <div class="footer-all">
    <div class="ndata-footer" :style="{marginTop:marginTopHeight+'PX'}">
      <el-divider class="footer-divider"/>
      <div class="footer-left">
        <div class="footer-img"></div>
        <span onclick="window.open('https://www.chinaswa.org')">https://www.chinaswa.org</span>
      </div>
      <div class="footer-content">
        <span class="footer-font">京ICP备17032276号-1</span>
        <div >
          <span v-for="(item,i) in footerList" :key="i" v-if="item.dictCode==='webname'" class="footer-font" >© {{year}}&nbsp;{{item.dictDescribe}}</span>
          <span v-for="(item,i) in footerList" :key="i" v-if="item.dictCode==='email'"  class="footer-font">&nbsp;&nbsp;邮箱:{{item.dictDescribe}}</span>
        </div>
        <span  class="footer-font">技术支持：恩数互联（北京）智能科技有限公司</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    topHeight: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      marginTopHeight: 10,
      year: new Date().getFullYear(),
      dictInfo: {}
    }
  },
  computed: {
    ...mapGetters(['footerList'])
  },
  watch: {
    topHeight: {
      handler (val) {
        console.log(val)
        this.marginTopHeight = val
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {}
}
</script>
<style lang="less" scoped >
  .footer-all{
    height: 120PX;
  }
  .ndata-footer{
    position: relative;
    line-height: 35px;
    background-color: #285ADC;
    height: 130px;
  }
  .footer-font{
    font-size: 14px;
    font-family: SourceHanSansCN-Regular-GBpc-EUC-H-, SourceHanSansCN-Regular-GBpc-EUC-H;
    font-weight: normal;
    color: #FFFFFF;
  }
  .footer-left{
    display: grid;
    float: left;
    padding-top: 20px;
    padding-left: 20px;
    .footer-img{
      width: 50px;
      height: 50px;
      margin-left: 50px;
      transition: all 0.4s;
      -moz-transition:all .4s;
      -webkit-transition:all .4s;
      -o-transition:all .4s;
      background: url("../assets/155@1x.png");
      background-repeat:no-repeat;   /* 不会重复 */
      background-position: center;   /* 是为了让图片放大的时候从中部放大，不会偏移 */
      background-size: 100% 100%;
      cursor: pointer;
      /*&:hover{*/
      /*  width: 200px;*/
      /*  height: 200px;*/
      /*  background-size: 150% 150%;*/
      /*}*/
    }
    span{
      cursor: pointer;
      color: #ffffff;
    }
  }
  .footer-divider{
    position: relative;
    bottom: 7px;
    border: solid 1px #285ADC;
    background: #285ADC;
    width: 1248px;
  }
  /deep/.el-divider--horizontal{
    height: 2px!important;
    margin: 10px 0px!important;
  }
  .footer-content{
    position: absolute;
    text-align: center;
    left: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue